import { useState, useEffect } from 'react';

import { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';

/**
 * Fetches our Stripe public key
 */
const loadStripeKey = async () => {
  const { NEXT_PUBLIC_API: domain } = process.env;
  const response = await fetch(`${domain}/api/config/stripe`);
  const body = await response.json();

  return body.data.stripe_pk;
};

export function useStripe() {
  const [stripePromise, setStripePromise] =
    useState<Promise<Stripe | null> | null>(null);
  const [stripeKeyLoading, setStripeKeyLoading] = useState<boolean>(false);
  const abc = async () => {
    setStripePromise(
      loadStripeKey().then((pk) => {
        setStripeKeyLoading(false);
        return loadStripe(pk);
      })
    );
  };
  useEffect(() => {
    if (stripePromise === null && stripeKeyLoading === false) {
      setStripeKeyLoading(true);
      abc();
    }
  }, []);

  return {
    stripePromise,
  };
}
